import React from "react";
import PropTypes from "prop-types";

export default function ChangeLogByUser(props) {
  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__title">Change Log</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <button className="btn btn-danger">
              <i className="fa fa-trash-o" aria-hidden="true"></i>
              Remove User
            </button>
          </p>
        </div>
      </div>
      <p>No API available.</p>
    </div>
  );
}

ChangeLogByUser.propTypes = {
  params: PropTypes.object
};
